import { render, staticRenderFns } from "./SceneEditDataPanel.vue?vue&type=template&id=63c9f0a4&scoped=true"
import script from "./SceneEditDataPanel.vue?vue&type=script&lang=js"
export * from "./SceneEditDataPanel.vue?vue&type=script&lang=js"
import style0 from "./SceneEditDataPanel.vue?vue&type=style&index=0&id=63c9f0a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c9f0a4",
  null
  
)

export default component.exports